import React, { useEffect, useMemo, useState } from "react";

const useDivDimensions = (ref: React.RefObject<HTMLDivElement>) => {
  const [divDimensions, setDivDimensions] = useState({
    width: 0,
    height: 0,
  });

  const observer = useMemo(
    () =>
      new ResizeObserver((sizes) => {
        sizes.forEach((size) => {
          setDivDimensions({
            height: size.contentRect.height,
            width: size.contentRect.width,
          });
        });
      }),
    [],
  );

  useEffect(() => {
    const div = ref;
    if (div.current) {
      observer.observe(div.current);
    }

    return () => {
      if (div.current) {
        observer.unobserve(div.current);
      }
    };
  }, [observer, ref]);

  return divDimensions;
};

export default useDivDimensions;
